import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Grid,
  GridItem
} from '@chakra-ui/react';
import Header from './components/header/Header';
import Navigation from './components/navigation/Navigation';
import Infoblocks from './components/infoblocks/InfoBlock';
import DetailsBlock from './components/detailsblock/DetailsBlock';
import TresholdScoreGraph from './components/tresholdScoreGraph/TresholdScoreGraph';
import Olympiads from './components/olympiads/Olympiads';
import Plan from './components/plan/Plan';
import SimilarSpecs from './components/similarSpecs/SimilarSpecs';
import InterestEvents from './components/interestingEvents/InterestEvents';
import { HomeProps } from './types/SpecInfo';
import Professions from './components/professions/Professions';


const Home: React.FC<HomeProps> = ({ specInfo }) => {
  const [id, setId] = useState(-1);
  const [color, setColor] = useState("#1C4289");

  const details = specInfo.content.map((item: any) => {
    return {
      name: item.content_type.title,
      html: item.content
    }
  })

  const COLORS = {
    "bach-spec": "#1C4289",
    "magistracy": "#1D8A3C",
    "spo": "#671D8A",
    "phd": "#8A1D1D",
    "default": "#1C4289",
  };

  type ColorKeys = keyof typeof COLORS;

  useEffect(() => {
    setColor(COLORS[specInfo.guide_direction.guide_education_level.slug as ColorKeys]);
  }, [])

  console.log(specInfo.partner_logo);

  return (
    <Flex 
      direction="column" 
      align="center" 
    >
        <Header
            specId={specInfo.id}
            directionCode={specInfo.guide_direction.code}
            directionName={specInfo.guide_direction.program}
            name={specInfo.name}
            details={details}
            description={specInfo.description}
            formUnit={specInfo.guide_direction.guide_formative_unit}
            eduLevel={specInfo.guide_direction.guide_education_level}
            eduLocation={specInfo.guide_direction.guide_education_location}
            favorite={!!specInfo.is_favorite}
            setDetailId={setId}
            color={color}
            partners={specInfo.partners ?? []}
        />

        <Navigation color={color}/>

        <Grid
            w='100%'
            color='#151515'
            templateColumns='1fr'
            my='50px'
            gap='100px'
            px={{
              base: '24px', 
              xl: '100px'
            }}
        >
            <GridItem id="info">
                <Infoblocks
                    specInfo={specInfo}
                    color={color}
                />
            </GridItem>
            {specInfo.scores &&
                specInfo.scores.length > 1 && (
                  <GridItem id="graph">
                    <Box>
                        <TresholdScoreGraph
                            scores={specInfo.scores}
                            eduLevel={specInfo.education_level_id}
                            color={color}
                        />
                    </Box>
                  </GridItem>
            )}
            {details.some((item: any) => item.html !== null) && (
              <GridItem id="details">
                <DetailsBlock 
                  details={details} 
                  video={specInfo.video_player_code}
                  color={color}
                />
              </GridItem>
            )}
            {/* {!!specInfo.professions_grouped && (
              <GridItem id="professions">
                <Professions
                  professions={specInfo.professions_grouped} 
                  color={color}
                />
              </GridItem>
            )} */}
            {!!specInfo.learning_plan.length && (
              <GridItem id="plan">
                  <Plan 
                    profileId={specInfo.id}
                    plan_version={specInfo.learning_plan} 
                    color={color}
                  />
              </GridItem>
            )} 
            {specInfo.guide_direction.olympiads && specInfo.guide_direction.olympiads.length > 0 && (
                <GridItem id="olympiads">
                    <Olympiads 
                      olympList={specInfo.guide_direction.olympiads} 
                      color={color}
                    />
                </GridItem>
            )}
            {/* {specInfo.similar_directions && (
              <GridItem id="similar">
                <SimilarSpecs similarDirections={specInfo.similar_directions} />
              </GridItem>
            )} */}
            {specInfo.guide_direction.events && specInfo.guide_direction.events.length > 0 && (
                <GridItem id="interest">
                    <InterestEvents similarEvents={specInfo.guide_direction.events} />
                </GridItem>
            )}
        </Grid>
    </Flex>
  );
};

export default Home;
